import createReactClass from "create-react-class";
import React from "react";
import { CompareList } from "../components/compareList";
import { compareDetailsStore } from "../stores/compareDetails";
import { subdivisionStore } from "../stores/subdivision";

function getStateFromStores() {
  return {
    subSelected: subdivisionStore.isSubSelected(),
    compareList: compareDetailsStore.getCompareList(),
    compareListLoading: compareDetailsStore.compareListLoading(),
    restrictionLoading: compareDetailsStore.restrictionLoading(),
    subdivisions: subdivisionStore.getSelectedSub(),
    isOpened: false,
  };
}

export const CompareDetailsView = createReactClass({
  componentDidMount: function () {
    subdivisionStore.subscribe(this._onChange);
    compareDetailsStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    subdivisionStore.unsubscribe(this._onChange);
    compareDetailsStore.subscribe(this._onChange);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  render: function () {
    var compareList = getCompareList(this.state);

    return (
      <div id="compareTabsOuterDiv" style={{ backgroundColor: "#b0c4de" }}>
        <div id="compareList">{compareList}</div>
      </div>
    );
  },
});

function getCompareList(state) {
  return (
    <CompareList loading={state.compareListLoading} data={state.compareList} />
  );
}
